import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ViewChild } from '@angular/core';
import { AsamcoAuthService, AsamcoUserService } from '@asamco/base';
import { UserService } from '@asamco/user-management/shared';
import { BehaviorSubject, Subject } from 'rxjs';
import { SelectedCompanyService } from '../selected-company/selected-company.service';
import { AdminLinkLogModalWrapperComponent } from './admin-link-log-modal-wrapper/admin-link-log-modal-wrapper.component';
import { AdminFinancialIssuesOverviewComponent } from './admin-financial-issues-overview/admin-financial-issues-overview.component';
import { AdminAuditLogsFunctionappComponent } from './admin-audit-logs-functionapp/admin-audit-logs-functionapp.component';
import { AdminAuditLogsPermissionsComponent } from './admin-audit-logs-permissions/admin-audit-logs-permissions.component';
import { AdminAuditLogsLinksLinksettingsUpdatesComponent } from './admin-audit-logs-links-linksettings-updates/admin-audit-logs-links-linksettings-updates.component';
import { AdminAuditLogsLinksComponent } from './admin-audit-logs-links/admin-audit-logs-links.component';
import { AdminAuditUserManagementComponent } from './admin-audit-user-management/admin-audit-user-management.component';
import { AdminAuditLogsCompaniesUsersComponent } from './admin-audit-logs-companies-users/admin-audit-logs-companies-users.component';
import { AdminLinkDisplayComponent } from './admin-link-display/admin-link-display.component';
import { NgIf, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';
import { ALTabsComponent } from '@asamco/application-link/shared';
import { AdminQueueLinkOverviewComponent } from './admin-queue-link-overview/admin-queue-link-overview.component';
import { AdminLinkMaintenanceComponent } from './admin-link-maintenance/admin-link-maintenance.component';

@Component({
    selector: 'app-shell-admin-link-overview',
    templateUrl: './admin-link-overview.component.html',
    styleUrls: ['../styles/alert.scss', '../styles/tile-style.scss', './admin-link-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgSwitch,
        NgSwitchCase,
        AdminLinkDisplayComponent,
        AdminAuditLogsCompaniesUsersComponent,
        AdminAuditUserManagementComponent,
        AdminAuditLogsLinksComponent,
        AdminAuditLogsLinksLinksettingsUpdatesComponent,
        AdminAuditLogsPermissionsComponent,
        AdminAuditLogsFunctionappComponent,
        AdminFinancialIssuesOverviewComponent,
		AdminQueueLinkOverviewComponent,
		AdminLinkMaintenanceComponent,
        AsyncPipe,
		ALTabsComponent,
		AdminQueueLinkOverviewComponent
    ],
})
export class AdminLinkOverviewComponent implements OnInit, OnDestroy {
	@ViewChild(AdminLinkLogModalWrapperComponent)
	editInfoModal: AdminLinkLogModalWrapperComponent;

	public isAdminSubject = new Subject<boolean>();
	public isAdminObservable = this.isAdminSubject.asObservable();

	private destroy$: Subject<void> = new Subject<void>();

	public tabInfo = [
		{
			id: 1,
			text: 'Link overview',
			icon: 'far fa-link',
		},
		{
			id: 2,
			text: 'Audit logs',
			icon: 'far fa-pencil',
		},
		{
			id: 3,
			text: 'Financial integration issues',
			icon: 'far fa-pencil',
		},
		{
			id: 4,
			text: 'Scheduler data',
			icon: 'far fa-pencil',
		},
		{
			id: 5,
			text: 'Maintenance / queue blocker',
			icon: 'far fa-wrench',
		},
	];
	public tabInfoAuditLogs = [
		{
			id: 1,
			text: 'Companies & Users',
			icon: 'far fa-users',
		},
		{
			id: 2,
			text: 'User management',
			icon: 'far fa-link',
		},
		{
			id: 3,
			text: 'Links - [Creation & Deletion]',
			icon: 'far fa-link',
		},
		{
			id: 4,
			text: 'Links & Link settings - [Updates]',
			icon: 'far fa-link',
		},
		{
			id: 5,
			text: 'Permissions',
			icon: 'far fa-link',
		},
		{
			id: 6,
			text: 'Function app',
			icon: 'far fa-link',
		},
	];;
	public selectedTab$ = new BehaviorSubject(1);
	public selectedAuditLogsTab$ = new BehaviorSubject(1);

	constructor(
		private asamcoUserService: AsamcoUserService,
		private userService: UserService,
		private companyService: SelectedCompanyService,
		private http: HttpClient,
		private auth: AsamcoAuthService
	) {}

	ngOnInit(): void {
		this.asamcoUserService.isAdmin().then(result => {
			this.isAdminSubject.next(result);
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
